/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function DoubleCheck({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12.453 2.293a.6.6 0 1 0-.906-.786L6.783 7.003 4.44 4.491a.6.6 0 0 0-.878.818l2.8 3a.6.6 0 0 0 .892-.016l5.2-6ZM12.453 8.793a.6.6 0 0 0-.906-.786l-4.764 5.496-2.344-2.512a.6.6 0 0 0-.878.819l2.8 3a.6.6 0 0 0 .892-.017l5.2-6Z" /></svg>;
}
;